import { createSelector } from 'reselect';

function getExperiments(state) {
  return state.experiments;
}

/**
 * @param {object} state
 * @param {string} experimentName
 * @returns {boolean} Is experiment enabled
 */
export const isEnabled = createSelector(
  [
    getExperiments,
    (state, experimentName) => experimentName,
  ],
  (experiments, experimentName) => _.get(experiments, experimentName) === 'true',
);

export function isNoCoverForEmbedEnabled(state) {
  return isEnabled(state, 'noCoverForEmbed');
}

export function isNewVideoAndChannelEditDesignEnabled(state) {
  return isEnabled(state, 'specs.newVideoAndChannelEditDesign');
}

export function isNewVideoPricingDesignEnabled(state) {
  return isEnabled(state, 'specs.newVideoPricingDesign');
}

export function isPremiumIntentEnabled(state) {
  return !isEnabled(state, 'specs.vod.disablePremiumIntent');
}

export function isSingularEnabled(state) {
  return isEnabled(state, 'specs.vod.singularIntegration');
}

export function isFacebookAuthEnabled(state) {
  return isEnabled(state, 'specs.vod.facebookAuth');
}

export function isShareEmbedButtonEnabled(state) {
  return isEnabled(state, 'specs.vod.ShareEmbedVideo');
}

export function isSocialShareEnabled(state) {
  return isEnabled(state, 'specs.vod.socialShare');
}

export function isLanguageSelectEnabled(state) {
  return isEnabled(state, 'specs.vod.languageSelect');
}

/**
 * @param {object} state
 * @returns {string[]} Enabled experiment names list
 */
export const getEnabledExperimentsList = createSelector(
  [
    getExperiments,
  ],
  experiments =>
    _(experiments)
      .pickBy(val => val === 'true')
      .keys()
      .value(),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/experiments.js